import React from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import { generateRedux } from '../../../1stlog-ui/src/components/InfinityTable/Redux'
import AddressTableShared from '../AddressTableShared'

export const redux = generateRedux({
  id: 'containers/AddressBookShared/',
  url: '/api/addressbook/list/infinity',
  initialState: {
    sortableColumns: ['id']
  }
  // sagas: [saga]
})

const connectRedux = connect(
  createStructuredSelector({
    ...redux.structuredSelector
    // additional selectors here
  }),
  {
    ...redux.actions
    // setAddressModal
  }
)

const AddressBookShared = (props) => {
  return <AddressTableShared {...props} />
}

export default connectRedux(AddressBookShared)
